import * as React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import classnames from 'classnames';

import { IOptionFields } from './Option';

import { OPTION_TYPES, QTYPES } from '@nexxt/common/types';

import { Project } from '@nexxt/common/types';

import OptionCardTextImage from './OptionCardImageText';
import OptionCardImage from './OptionCardImage';
import OptionCardText from './OptionCardText';
import OptionCardHighlight from './OptionCardHighlight';
import OptionSetting from '../optionSetting';

export interface CardProps {
    option: IOptionFields | any;
    isTypeScale?: boolean;
    optionsError: any[];
    optionIndex: number;
    currentProject: Project;
    languages?: any[];
    isRichText: boolean;
    showRandomize: boolean;
    selectedOptionType: OPTION_TYPES;
    useDragHandle: boolean;
    qtype?: string;
    editEnabled?: boolean;
    optionSettings?: any;
    handleChange: (index: number, event: any) => void; // Handle Label
    handleChangeWithValue?: (index: number, label: string, value: any) => void;
    handleToggleValueChange: (
        index: number,
        keyName: string,
        value: any
    ) => void;
    handleLanguageChange: (
        index: number,
        textIndex: number,
        value: any,
        langauge: any
    ) => void; // handle normal text with language
    handleRichText: (
        index: number,
        textIndex: number,
        value: any,
        langauge: any
    ) => void; // handle rich text with language
    handleRemoveOptionField: (index: number) => void;
    openMediaLibrary: (index: number) => void;
    onSortEnd: (dragIndex: number, hoverIndex: number) => void;
}

class Card extends React.Component<CardProps> {
    handleRemoveOptionField = (event) => {
        event.stopPropagation();
        this.props.handleRemoveOptionField(this.props.optionIndex);
    };

    closeButton = () => {
        const { props } = this;
        return (
            <div
                className="option-box--close"
                onClick={this.handleRemoveOptionField}
            >
                <i className="nx nx-close" />
            </div>
        );
    };

    switchOptions = () => {
        const { optionIndex, optionsError, option, qtype } = this.props;
        const optionError = (optionsError || {})[optionIndex] || {};

        switch (this.props.selectedOptionType) {
            case OPTION_TYPES.TEXT_ONLY:
                return (
                    <OptionCardText
                        {...this.props}
                        option={option}
                        index={optionIndex}
                        optionError={optionError}
                    />
                );
            case OPTION_TYPES.IMAGE_ONLY:
                return (
                    <OptionCardImage
                        {...this.props}
                        option={option}
                        index={optionIndex}
                        optionError={optionError}
                    />
                );
            case OPTION_TYPES.IMAGE_AND_TEXT:
                return (
                    <OptionCardTextImage
                        {...this.props}
                        option={option}
                        index={optionIndex}
                        optionError={optionError}
                    />
                );
            case OPTION_TYPES.HIGHLIGHT:
                return (
                    <OptionCardHighlight
                        {...this.props}
                        option={option}
                        index={optionIndex}
                        optionError={optionError}
                    />
                );
            default:
                return <React.Fragment />;
        }
    };

    render() {
        const { optionSettings } = this.props;
        return (
            <div className={classnames(`option-box`)}>
                {optionSettings &&
                    !optionSettings.disableDrag &&
                    this.props.editEnabled && <DragHandle />}
                {optionSettings &&
                    !optionSettings.disableRemove &&
                    this.props.editEnabled &&
                    this.closeButton()}
                {this.switchOptions()}
            </div>
        );
    }
}

const DragHandle = SortableHandle(() => (
    <div className="option-card-drag"></div>
));

export default SortableElement(Card);
